export const INIT_DOLLS = "INIT_DOLLS";
export const FILTER_DOLLS = "FILTER_DOLLS";
export const INIT_FILTERS = "INIT_FILTERS";